// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Converts units of rem to units of pixels
 * @param rem - units of rem
 * @returns units of pixels
 */
export const convertRemToPx = (rem) => {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
};
//# sourceMappingURL=common.js.map